import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=064085bf&scoped=true"
import script from "./doc.vue?vue&type=script&lang=js"
export * from "./doc.vue?vue&type=script&lang=js"
import style0 from "./doc.vue?vue&type=style&index=0&id=064085bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064085bf",
  null
  
)

export default component.exports